import Axios from '~/utils/axios';
/**
 *
 * @param {boolean} bnpl_agreed
 * @returns
 */

type BnplChangeStateType = {
   bnpl_agreed: boolean;
   tabby_active: boolean;
   tamara_active: boolean;
};

export const bnplChangeState = async ({
   bnpl_agreed,
   tabby_active,
   tamara_active,
}: BnplChangeStateType) => {
   try {
      const { data: response } = await Axios.post('/hy-providers/v1/bnpl/send', {
         bnpl_agreed,
         tabby_active,
         tamara_active,
      });
      if (response?.status === 'Success') {
         return { response, error: false };
      } else {
         throw new Error(response?.error || response?.original?.error || 'Something went wrong');
      }
   } catch (error: any) {
      return { error };
   }
};
